import { ui } from '../../styles/ui'

const STYLE_BY_HEALTH = {
  fresh: ui.badges.success,
  available: ui.badges.success,
  stale: ui.badges.warning,
  missing: ui.badges.danger,
  failed: ui.badges.danger,
  unsupported: ui.badges.neutral,
  derived: ui.badges.info,
}

export default function ExchangeRateHealthBadge({ label, health }) {
  const normalized = String(health || 'unknown').toLowerCase()
  const style = STYLE_BY_HEALTH[normalized] || ui.badges.neutral
  const text = label || normalized.charAt(0).toUpperCase() + normalized.slice(1)

  return (
    <span className={`${ui.badges.base} ${style}`}>
      {text}
    </span>
  )
}
